var _rect, _path, _g, _g2, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPopperLogoTwo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 104,
    viewBox: "0 0 212 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 30.4805,
    width: 150,
    height: 10,
    rx: 2,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2713_35584",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 30,
    width: 76,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 32.4805C31 31.3759 31.8954 30.4805 33 30.4805H106.001V40.4805H33C31.8954 40.4805 31 39.585 31 38.4805V32.4805Z",
    fill: "url(#paint0_linear_2713_35584)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2713_35584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 32.4805C31 31.3759 31.8954 30.4805 33 30.4805H181V40.4805H33C31.8954 40.4805 31 39.585 31 38.4805V32.4805Z",
    fill: "url(#paint1_linear_2713_35584)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2713_35584)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106 22.2578C113.303 22.2578 119.223 28.1779 119.223 35.4807C119.223 42.7835 113.303 48.7036 106 48.7036C98.6974 48.7036 92.7773 42.7835 92.7773 35.4807C92.7773 28.1779 98.6974 22.2578 106 22.2578Z",
    fill: "url(#paint2_angular_2713_35584)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106 22.2578C113.303 22.2578 119.223 28.1779 119.223 35.4807C119.223 42.7835 113.303 48.7036 106 48.7036C98.6974 48.7036 92.7773 42.7835 92.7773 35.4807C92.7773 28.1779 98.6974 22.2578 106 22.2578Z",
    stroke: "white",
    strokeWidth: 2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5386 72.2286C88.9981 71.6884 88.5821 71.0368 88.3196 70.3192C88.0571 69.6016 87.9543 68.8354 88.0186 68.074C88.0828 67.3126 88.3125 66.5744 88.6915 65.9109C89.0706 65.2475 89.5899 64.6748 90.2132 64.2328C91.2831 63.5245 92.5675 63.2138 93.8429 63.3548C95.1182 63.4958 96.3037 64.0796 97.1931 65.0046L101.167 68.9657V35.9563C101.169 35.1904 101.338 34.434 101.662 33.7401C101.987 33.0462 102.458 32.4314 103.045 31.9385C103.631 31.4457 104.318 31.0866 105.057 30.8865C105.797 30.6864 106.571 30.65 107.326 30.7798C108.582 31.0316 109.709 31.7176 110.51 32.7173C111.311 33.7171 111.735 34.9669 111.707 36.2477V49.0813H124.693C126.499 49.0497 128.283 49.4817 129.874 50.3361C131.717 51.3479 133.208 52.8969 134.148 54.7767C135.089 56.6566 135.435 58.7784 135.14 60.8597L134.035 68.5798C133.405 72.9611 131.37 77.0196 128.236 80.1455C126.268 82.1065 123.602 83.2071 120.823 83.2063H104.895C102.117 83.2064 99.4525 82.1058 97.4844 80.1455L89.5386 72.2286Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2713_35584",
    x: 83.7773,
    y: 15.2578,
    width: 44.4453,
    height: 44.4458,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2713_35584"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2713_35584"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2713_35584",
    result: "effect2_dropShadow_2713_35584"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2713_35584",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2713_35584",
    x1: 104.145,
    y1: 40.4805,
    x2: 31,
    y2: 40.4805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2713_35584",
    x1: 177.287,
    y1: 40.4805,
    x2: 31,
    y2: 40.4805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_angular_2713_35584",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(106.368 38.7864) rotate(-78.1431) scale(17.915 17.5876)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.158891,
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295705,
    stopColor: "#030972"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#88B04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867719,
    stopColor: "#EB6E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980299,
    stopColor: "#BF1932"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopperLogoTwo);
export default __webpack_public_path__ + "static/media/popperLogoTwo.44e13e18ae26c84f453bdd821ae1589e.svg";
export { ForwardRef as ReactComponent };